import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d75a44a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-contract-info-wrap" }


import TitleText from "@/components/common/TitleText.vue";
import ListRow from "@/components/common/list/ListRow.vue";
import IconContract from "@/assets/svgs/icon_contract.svg";
import { ICompanyInvoice } from "@/models/company-invoice";

interface IProps {
  companyInvoice: ICompanyInvoice;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CardContractInfo',
  props: {
    companyInvoice: {}
  },
  setup(__props: any) {

const props = __props;



const columns = [
  {
    header: "契約プラン",
    text: props.companyInvoice.labels.contract_plan,
  },
  {
    header: "年次契約",
    text: `${props.companyInvoice.annually_contract_count.toLocaleString()} ID`,
  },
  {
    header: "年次契約における備考",
    text: props.companyInvoice.annually_contract_memo || '-',
  },
  {
    header: "月次契約",
    text: `${props.companyInvoice.monthly_contract_count.toLocaleString()} ID`,
  },
  {
    header: "月次契約における備考",
    text: props.companyInvoice.monthly_contract_memo || '-',
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TitleText, {
      text: "契約情報",
      "with-icon": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IconContract), { class: "icon" })
      ]),
      _: 1
    }),
    _createVNode(ListRow, { columns: columns })
  ]))
}
}

})